import Aegis from '@tencent/aegis-web-sdk';
import { isNewVersion, getCacheType, getStartTime, getUin } from './utils';

// aegis对象
let aegis: Aegis | undefined = undefined;

// aegis默认配置
const defConfig: AegisConfig & {
  whiteListUrl: string,
  pvUrl: string,
  onError: boolean,
  hostUrl: string
} = {
  id: '',
  uin: getUin(), // 用户唯一 ID（可选）
  whiteListUrl: '',
  pvUrl: '',
  reportAssetSpeed: false, // 静态资源测速
  onError: false,
  hostUrl: 'https://ft.moneydata.hk/aegis',
  spa: true, // spa 页面需要开启，页面切换的时候上报pv
};

/**
 * Aegis参数配置
 */
export type AegisConfig = {
  /**
     * 项目标示ID（一般是项目英文名称）
     */
  id: string,
  /**
     * 用户唯一 ID（可选）
     */
  uin?: string,
  /**
     *  静态资源测速上报
     */
  reportAssetSpeed?: boolean,
  /**
     * spa 页面需要开启，页面切换的时候上报pv
     */
  spa?: boolean,
};

/**
 * 初始化aegis
 * @param config aegis配置信息
 * @returns
 */
export function init(config: AegisConfig) {
  const options = {
    ...defConfig,
    ...config,
  };
  if (!options.id) {
    throw new Error('aegis\'s id is null');
  }
  Object.assign(options, {
    // 上报整体资源的命中缓存状态
    ext1: getCacheType().toString(),
    // 上报用户页面版本访问情况（新构建的版本or历史缓存版本）
    ext2: isNewVersion(options.id) ? '0' : '1',
  });

  aegis = new Aegis(options);
  return aegis;
}

/**
 * 上报自定义测速点
 * 上报从页面启动到具体上报点之间的时间差
 * @param speedPointKey 上报点ID
 */
function reportTime(speedPointKey: string) {
  const startTime = getStartTime();
  getInstance().reportTime(speedPointKey, new Date().getTime() - startTime);
}

/**
 * 获取aegis实例
 * @returns
 */
function getInstance() {
  if (!aegis) {
    throw new Error('aegis instance is null, please init at first');
  }
  return aegis;
}

export default {
  init,
  reportTime,
  getInstance,
};
